import { render, staticRenderFns } from "./ManagementDashboardsModule.vue?vue&type=template&id=1e111988"
import script from "./ManagementDashboardsModule.vue?vue&type=script&lang=js"
export * from "./ManagementDashboardsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports